import { ref, watch } from '@vue/composition-api'
import store from '@/store'

export default function controller() {
  const blankItem = {
    id: null,
    name: null,
  }
  const form = ref(null)
  const items = ref([])
  const item = ref({})
  const tableColumns = [
    { text: 'Nom', value: 'name' },
    { text: 'Responsables', value: 'collection_users' },
    {
      text: 'Actions',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]
  const isSnackbarBottomVisible = ref(false)
  const snackBarMessage = ref('')
  const isFormActive = ref(false)
  const deleteDialog = ref(false)
  const searchQuery = ref('')
  const totalItems = ref(0)
  const current_parent_id = ref(0)
  const loading = ref(false)
  const options = ref({
    rowsPerPage: 10,
    page: 1,
    sortDesc: [false],
  })
  const page = ref(1)
  const pageCount = ref(0)
  const selectedRows = ref([])
  const resetForm = () => {
    if (form.value) form.value.reset()
  }

  // new item
  const openDialog = val => {
    if (val) {
      item.value = val
    } else {
      item.value = JSON.parse(JSON.stringify(blankItem))
      item.value.id_parent = current_parent_id.value
      resetForm()
    }
    isFormActive.value = !isFormActive.value
  }

  const loadChildren = val => {
    if (val) {
      let id_parent = val.id
      current_parent_id.value = id_parent
      fetchItems(id_parent, true)
    }
  }

  const itemsBreadcrumbs = ref([])

  // fetch data
  const fetchItems = (id_parent = 0, id_view_children = false) => {
    isFormActive.value = false

    let payload = {
      orderBy: options.value.sortBy ? (options.value.sortBy[0] || 'name') : 'name',
      // eslint-disable-next-line no-nested-ternary
      direction: options.value.sortDesc ? (options.value.sortDesc[0] ? 'DESC' : 'ASC') : 'DESC',
      page: options.value.page,
      per_page: options.value.itemsPerPage,
      id_parent,
    }

    // eslint-disable-next-line camelcase
    if (!id_view_children) {
      payload = { ...payload, term: searchQuery.value }
    }

    store
      .dispatch('collection/fetchItems', payload)
      .then(response => {
        const { data, total, breadcrumbs } = response.data


        items.value = data.data
        totalItems.value = total

        itemsBreadcrumbs.value = breadcrumbs.map(item => ({
          ...item,
          href: '#',
        }))

        // remove loading state
        loading.value = false
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        loading.value = false
      })
  }
  const confirmDelete = val => {
    item.value = val
    deleteDialog.value = true
  }
  const deleteItem = () => {
    if (item.value) {
      loading.value = true
      store.dispatch('collection/deleteItem', item.value.id)
        .then(response => {
          fetchItems(item.value.id_parent)
          deleteDialog.value = false
          loading.value = false
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {

      })
    }
  }

  watch([searchQuery, options], () => {
    loading.value = true
    selectedRows.value = []
    fetchItems()
  })

  return {
    item,
    items,
    tableColumns,
    searchQuery,
    itemsBreadcrumbs,
    totalItems,
    loading,
    options,
    selectedRows,
    isFormActive,
    blankItem,
    current_parent_id,
    form,
    page,
    pageCount,
    snackBarMessage,
    isSnackbarBottomVisible,
    deleteDialog,
    resetForm,
    openDialog,
    loadChildren,
    confirmDelete,
    deleteItem,
    fetchItems,
  }
}
